import { motion } from "framer-motion";
import { Award, MapPin, Star, Stethoscope } from "lucide-react";

const items = [
  { icon: Stethoscope, label: "12+ Years in Dentistry" },
  { icon: Award, label: "U.S. Army Dental Background" },
  { icon: MapPin, label: "Port St. Lucie & Treasure Coast" },
  { icon: Star, label: "5-Star Client Reviews" },
];

const CredibilityStrip = () => {
  return (
    <section className="border-y border-border bg-card/50">
      <div className="max-w-6xl mx-auto px-6 py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {items.map((item, i) => (
            <motion.div
              key={item.label}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="flex items-center gap-3 justify-center"
            >
              <item.icon className="w-5 h-5 text-primary flex-shrink-0" />
              <span className="text-sm font-semibold text-foreground/80 text-center">{item.label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CredibilityStrip;
